import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { Button, Spin2, Collapse } from "components";
import { validationSchemaVariant, initialValues } from "../components/common";
import { Main, Payment, Additional, Pricing, Product, VariantInfo, Discord, Telegram } from "../components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Tooltip } from "@paylixecommerce/shared/components";
import ClosePage from "../components/save-close";
import config from "constants/config";
import { createProduct } from "../../actions";
import { ChevronUp, ChevronDown } from "../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../../../../../../hooks/useMobile";
import { TipsIcon } from "../detail/product";

import "../components/style.scss";


const CreateProduct = () => {

    const [gateways, setGateways] = useState({});
    const [delimiter, setDelimiter] = useState(config.DELIMITER_OPTIONS[0].value);
    const [created, setCreated] = useState(false);
    const isMobile = useMobile();

    const [closeConfirmModal, setShowConfirmModal] = useState(false);

    const [volumeDiscounts, setVolumeDiscounts] = useState([]);
    const [customFields, setCustomFields] = useState([]);
    const [webhooks, setWebhooks] = useState([]);
    const [variants, setVariants] = useState([]);
    const [progress, setProgress] = useState(0);
    const [variantsQuantityError, setVariantsQuantityError] = useState("");
    const [discordServerError, setDiscordServerError] = useState("");
    const [telegramServerError, setTelegramServerError] = useState("");

    const [generalInfo, showGeneralInfo] = useState(true);
    const [pricingInfo, showPricingInfo] = useState(false);
    const [paymentInfo, showPaymentInfo] = useState(false);
    const [variantsInfo, showVariantsInfo] = useState(false);
    const [productInfo, showProductInfo] = useState(false);
    const [discordInfo, showDiscordInfo] = useState(false);
    const [telegramInfo, showTelegramInfo] = useState(false);
    const [additionalInfo, showAdditionalInfo] = useState(false);

    useEffect(() => {
        if(variants.length >= 2) {
            setVariantsQuantityError("")
        }
    }, [variants])

    const generalInfoRef = useRef(null);
    const generalInfoScroll = () => {
        setTimeout(() => {
            generalInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const pricingInfoRef = useRef(null);
    const pricingInfoScroll = () => {
        setTimeout(() => {
            pricingInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const paymentInfoRef = useRef(null);
    const paymentInfoScroll = () => {
        setTimeout(() => {
            paymentInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const variantsInfoRef = useRef(null);
    const variantsInfoScroll = () => {
        setTimeout(() => {
            variantsInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const productInfoRef = useRef(null);
    const productInfoScroll = () => {
        setTimeout(() => {
            productInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const additionalInfoRef = useRef(null);
    const additionalInfoScroll = () => {
        setTimeout(() => {
            additionalInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const discordRef = useRef(null);
    const discordScroll = () => {
        setTimeout(() => {
            discordRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const telegramRef = useRef(null);
    const telegramScroll = () => {
        setTimeout(() => {
            telegramRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {

        if(location.state && location.state.isSerials) {
            showGeneralInfo(false);
            showProductInfo(true);
            productInfoScroll();
        }

    }, [location.state])

    const configs = {
        onUploadProgress: progressEvent => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
        }
    }

    const onSubmit = (values, {setErrors}) => {

        setCreated(true);

        if (values.manuallyWarranty && +values.manuallyWarranty < 900) {
            setErrors({
                manuallyWarranty: "Must be more then 900 seconds"
            });
            return;
        }

        let data = {...values};

        data.gateways = Object.keys(gateways).filter(key => gateways[key]).toString();
        data.custom_fields = JSON.stringify({
            custom_fields: customFields.map(field => ({...field, type: field.type}))
        });
        data.volume_discounts = JSON.stringify({volume_discounts: volumeDiscounts});
        data.price_variants = JSON.stringify(variants);
        data.stock = values.showStock ? data.stock : -1;
        data.subtype = values.subtype || "";
        data.price_discount = +values.price_discount;
        data.redirect_link = data.redirect_enabled ? (values.redirect_link || "") : "";
        data.delivery_text = data.delivery_text_enabled ? (values.delivery_text || "") : "";
        data.affiliate_revenue_percent = values.affiliate_revenue_percent;
        data.licensing_enabled = Boolean(values.licensing_enabled) || 0;

        data.watermark_enabled = values.watermark_enabled;
        data.watermark_text = values.watermark_text;
        data.redirect_link = values.redirect_link || "";

        if(data.quantity_max === "" || data.quantity_max === 0 || data.quantity_max === 0) {
            data.quantity_max = "0";
        }

        if(data.stock_delimiter === "↵") {
            data.stock_delimiter = "\n"
        }

        let warranty = values.warranty;

        if(values.warranty === "1") {
            warranty = values.manuallyWarranty;
            delete values.manuallyWarranty;
        }

        data.warranty = warranty;

        data.image.forEach(({lastModified}, key) => {
            if (lastModified === data.default_image) {
                data.default_image = key;
            }
        });

        if (!data.default_image && data.default_image !== 0) {
            data.default_image = 0;
        }

        data.currency = typeof data.currency === "string" ? data.currency : data.currency.value;

        data.webhooks = webhooks;
        data.unlisted = Boolean(data.unlisted);
        data.private = Boolean(data.private);
        data.block_vpn_proxies = Boolean(data.block_vpn_proxies);
        data.on_hold = Boolean(data.on_hold);

        data.serials_remove_duplicates = values.removeDuplicates;

        delete data.tos_enabled;
        delete data.warranty_enabled;
        delete data.redirect_enabled;
        delete data.delivery_text_enabled;
        delete data.removeDuplicates;

        data.discord_integration = Boolean(data.discord_integration);

        if(data.discord_integration) {
            data.discord_server_id = data.discord_server_id || "none";
            data.discord_set_role = Boolean(data.discord_set_role);
            data.discord_role_id = data.discord_role_id || "";
            data.discord_remove_role = Boolean(data.discord_remove_role);
            data.discord_optional = Boolean(data.discord_optional);
        } else {
            data.discord_server_id = "none";
            data.discord_set_role = false;
            data.discord_role_id = "";
            data.discord_remove_role = false;
            data.discord_optional = false;
        }

        data.telegram_integration = !!data.telegram_integration;
        if (data.telegram_integration) {
            data.telegram_group_id = data.telegram_group_id || "none";
            data.telegram_optional = !!data.telegram_optional;
        } else {
            data.telegram_group_id = "none";
            data.telegram_optional = false;
        }

        dispatch(createProduct(data, configs))
            .then(res => {
                toastAlert('success', res.message);
                history.push('/products');
                setProgress(0);
            })
            .catch(err => {
                toastAlert('error', err ? err.error : "");
                setProgress(0);
                if(err && err.error) {
                    if(err.error === "Dynamic Webhook Url is required for type or subtype Dynamic." || err.error === "You must upload a File for product type File.") {
                        if (isMobile) {
                            showProductInfo(true);
                        }

                        if (!productInfo) {
                            productInfoScroll();
                        }

                        showProductInfo(true);
                    }
                }
            })
            .finally(() => {
                setCreated(false);
                setProgress(0);
            })
    };

    let form = useFormik({
        validationSchema: validationSchemaVariant,
        enableReinitialize: true,
        initialValues: {...initialValues, currency: "USD"},
        onSubmit
    });


    useEffect(() => {
        if(form.values.discord_server_id && form.values.discord_server_id !== "none") {
            setDiscordServerError("");
        }
    }, [form.values.discord_server_id]);

    useEffect(() => {
        if (form.values.telegram_group_id && form.values.telegram_group_id !== "none") {
            setTelegramServerError("");
        }
    }, [form.values.telegram_group_id]);

    return <>

        <div className="edit-modal-header" style={{borderBottom: "none"}}>
            <div className="edit-modal-header-title">New Product with Variants</div>
        </div>

        <div className="edit-modal-body">

            <form onSubmit={form.handleSubmit} className="product-form mb-0">

                <div className="product-progress" style={{width: `${progress}%`}}/>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={generalInfoRef}
                         onClick={() => {
                            if (isMobile) {
                                showPricingInfo(false);
                                showProductInfo(false);
                                showPaymentInfo(false);
                                showVariantsInfo(false);
                                showAdditionalInfo(false);
                                showDiscordInfo(false);
                                showTelegramInfo(false);
                            }
                            if (!generalInfo) {
                                generalInfoScroll();
                            }
                            showGeneralInfo(!generalInfo);
                        }}
                    >
                        <div className="d-flex">
                            {generalInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>General Info</span>
                        </div>
                    </div>

                    <Collapse isOpen={generalInfo}>
                        <Main isVariant form={form}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={productInfoRef}
                         onClick={() => {
                            if (isMobile) {
                                showGeneralInfo(false);
                                showProductInfo(true);
                                showPaymentInfo(false);
                                showVariantsInfo(false);
                                showAdditionalInfo(false);
                                showDiscordInfo(false);
                                showTelegramInfo(false);
                            }
                            if (!productInfo) {
                                productInfoScroll();
                            }
                            showProductInfo(!productInfo);
                        }}
                    >
                        <div className="d-flex">
                            {productInfo ? <ChevronUp /> : <ChevronDown />}
                            <span>Product</span>
                        </div>
                    </div>
                    <Collapse isOpen={productInfo}>
                        <Product isVariant form={form} setDelimiter={setDelimiter} delimiter={delimiter}/>
                    </Collapse>
                </div>


                <div className="product-block">
                    <div className="product-block-header"
                         ref={pricingInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showProductInfo(false);
                                 showPricingInfo(true);
                                 showPaymentInfo(false);
                                 showVariantsInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }

                             if (!productInfo) {
                                 pricingInfoScroll();
                             }

                             showPricingInfo(!pricingInfo);
                         }}
                    >
                        <div className="d-flex">
                            {pricingInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Currency and Discount</span>
                        </div>
                    </div>
                    <Collapse isOpen={pricingInfo}>
                        <Pricing isVariant form={form}/>
                    </Collapse>
                </div>


                <div className="product-block">
                    <div className="product-block-header"
                         ref={variantsInfoRef}
                         onClick={() => {
                            if (isMobile) {
                                showGeneralInfo(false);
                                showPricingInfo(false);
                                showPaymentInfo(false);
                                showProductInfo(false);
                                showVariantsInfo(true);
                                showAdditionalInfo(false);
                                showDiscordInfo(false);
                                showTelegramInfo(false);
                            }
                            if (!variantsInfo) {
                                variantsInfoScroll();
                            }
                            showVariantsInfo(!variantsInfo);
                        }}
                    >
                        <div className="d-flex">
                            {variantsInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Variants</span>
                        </div>
                    </div>
                    <Collapse isOpen={variantsInfo}>
                        <VariantInfo setDelimiter={setDelimiter} variantsQuantityError={variantsQuantityError} isVariant form={form} variants={variants} setVariants={setVariants} />
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={paymentInfoRef}
                         onClick={() => {
                            if (isMobile) {
                                showGeneralInfo(false);
                                showProductInfo(false);
                                showPricingInfo(false);
                                showPaymentInfo(true);
                                showVariantsInfo(false);
                                showAdditionalInfo(false);
                                showDiscordInfo(false);
                                showTelegramInfo(false);
                            }
                            if (!paymentInfo) {
                                paymentInfoScroll();
                            }
                            showPaymentInfo(!paymentInfo);
                        }}
                    >
                        <div className="d-flex">
                            {paymentInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Payment Methods</span>
                        </div>
                    </div>
                    <Collapse isOpen={paymentInfo}>
                        <div className="product-form-main-back pb-0">
                            <Payment setGateways={setGateways} gateways={gateways}/>
                        </div>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={discordRef}
                         onClick={() => {
                            if(isMobile) {
                                showGeneralInfo(false);
                                showPricingInfo(false);
                                showPaymentInfo(false);
                                showAdditionalInfo(false);
                                showDiscordInfo(false);
                            }
                            if(!discordInfo) {
                                discordScroll();
                            }
                            showDiscordInfo(!discordInfo);
                        }}
                    >
                        <div className="d-flex">
                            {discordInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Discord Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={discordInfo}>
                        <Discord discordServerError={discordServerError} form={form} />
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={telegramRef}
                         onClick={() => {
                             if(isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if(!telegramInfo) {
                                 telegramScroll();
                             }
                             showTelegramInfo(!telegramInfo);
                         }}
                    >
                        <div className="d-flex">
                            {telegramInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Telegram Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={telegramInfo}>
                        <Telegram telegramServerError={telegramServerError} form={form} />
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={additionalInfoRef}
                         onClick={(e) => {
                             if(e.target.tagName === 'A') {
                                 return ""
                             } else {
                                 if (isMobile) {
                                     showGeneralInfo(false);
                                     showPricingInfo(false);
                                     showProductInfo(false);
                                     showPaymentInfo(false);
                                     showVariantsInfo(false);
                                     showAdditionalInfo(true);
                                     showDiscordInfo(false);
                                     showTelegramInfo(false);
                                 }
                                 if (!additionalInfo) {
                                     additionalInfoScroll();
                                 }
                                 showAdditionalInfo(!additionalInfo);
                             }
                        }}
                    >
                        <div className="d-flex">
                            {additionalInfo ? <ChevronUp /> : <ChevronDown />}
                            <span className="d-flex">
                                Additional Details
                                <Link to="/utils" target="_blank" className="ml-3 badge badge-paylixecommerce">
                                    <Tooltip tooltipText={`Go to Products -> Utils in your sidebar to update multiple products at once.`} name="extra-info" className="d-flex align-items-center justify-content-center color-purple" >
                                        <TipsIcon /> Did You Know?
                                    </Tooltip>
                                </Link>
                            </span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={additionalInfo}>
                        <Additional
                            form={form}
                            volumeDiscounts={volumeDiscounts}
                            setVolumeDiscounts={setVolumeDiscounts}
                            customFields={customFields}
                            setCustomFields={setCustomFields}
                            webhooks={webhooks}
                            setWebhooks={setWebhooks}
                            gateways={gateways}
                        />
                    </Collapse>
                </div>

            </form>

        </div>


        <ClosePage to="/products" open={closeConfirmModal} close={() => setShowConfirmModal(false)}/>
        <div className="edit-modal-footer">
            <Button type="button" size="large" disabled={created} variant="secondary" onClick={() => {
                if (form.dirty) {
                    setShowConfirmModal(true);
                } else {
                    history.push('/products');
                }
            }}>
                {form.dirty ? "Cancel" : "Close"}
            </Button>
            <Button type="button" size="large" iconName={created ? "" : "plus"} disabled={created} iconPosition="left"
                    onClick={() => {
                        if (form.errors.description) {

                            if (isMobile) {
                                showGeneralInfo(true);
                            }

                            if (!generalInfo) {
                                generalInfoScroll();
                            }

                            showGeneralInfo(true);
                            form.handleSubmit();

                        } else if (variants.length < 2) {

                            if (isMobile) {
                                showVariantsInfo(true);
                            }

                            if (!variantsInfo) {
                                variantsInfoScroll();
                            }

                            setVariantsQuantityError("Must have min 2 variants")

                            showVariantsInfo(true);

                        } else if(form.values.discord_integration && (!form.values.discord_server_id || form.values.discord_server_id === "none")) {
                            if (isMobile) {
                                showDiscordInfo(true);
                            }

                            if (!discordInfo) {
                                discordScroll();
                            }

                            setDiscordServerError("You need to select a server if you want to use Discord");

                            showDiscordInfo(true);
                        } else if(form.values.telegram_integration && (!form.values.telegram_group_id || form.values.telegram_group_id === "none")) {
                            if (isMobile) {
                                showTelegramInfo(true);
                            }

                            if (!telegramInfo) {
                                telegramScroll();
                            }

                            setTelegramServerError("You need to select a group if you want to use Telegram");

                            showTelegramInfo(true);
                        } else if (!form.values.type) {
                            if (isMobile) {
                                showProductInfo(true);
                            }

                            if (!productInfo) {
                                productInfoScroll();
                            }

                            showProductInfo(true);
                        } else {
                            form.handleSubmit();
                        }
                    }}>
                {created ? <Spin2 /> : `Create Product Variant`}
            </Button>
        </div>

    </>
}

export default CreateProduct;

